const homesReadmore = () => {
  const content = document.querySelector(".js-readmore-content");
  if (!content) {
    return;
  }
  const firstP = content.querySelector("p");
  const button = document.querySelector(".js-homes-readmore");
  button.addEventListener("click", () => {
    content.classList.toggle("active");
    if (content.classList.contains("active")) {
      button.classList.add("active");
      button.querySelector("p").innerText = "READ LESS";
    } else {
      button.classList.remove("active");
      button.querySelector("p").innerText = "READ MORE";
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  });

  const resizeContent = () => {
    if (window.innerWidth < 768) {
      let heightP = firstP.getBoundingClientRect().height;
      let heightB = button.getBoundingClientRect().height;
      let maxH = heightB + heightP + "px";
      content.style.maxHeight = maxH;
    } else {
      content.style.maxHeight = "unset";
    }
  };
  if (window.innerWidth < 768) {
    resizeContent();
  }

  window.addEventListener("resize", resizeContent);
};

export default homesReadmore;
